
export const languages = [
    {
        label: 'English',
        culture: 'en-GB',
        order: 0,
        key: 'translations.english',
        flag: './assets/images/flags/gb.svg',
    },
    {
        label: 'Nederlands',
        culture: 'nl-NL',
        order: 0,
        key: 'translations.dutch',
        flag: './assets/images/flags/nl.svg',
    },            
    {
        label: 'Deutsch',
        culture: 'de-DE',
        order: 0,
        key: 'translations.german',
        flag: './assets/images/flags/de.svg',
    },
    {
        label: 'Italiano',
        culture: 'it-IT',
        order: 0,
        key: 'translations.italian',
        flag: './assets/images/flags/it.svg',
    },
    {
        label: "Francais",
        culture: "fr-FR",
        order: 0,
        key: 'translations.french',
        flag: './assets/images/flags/fr.svg'
    },
    /*{
        label: 'Romana',
        culture: 'ro',
        order: 0,
        key: 'translations.romanian',
        flag: './assets/images/flags/ro.svg',
    },*/
];



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-languages-drop-down/djiv-language.config.ts